(() => {
  'use strict';

  const loader = document.querySelector('[data-bh-page-loader]');
  if (!loader) return;

  const minimumVisibleMs = 420;
  const maximumVisibleMs = 3200;
  const startedAt = performance.now();
  let hideTimer = 0;
  let navigationTimer = 0;
  let failsafeTimer = 0;

  const show = () => {
    window.clearTimeout(hideTimer);
    window.clearTimeout(failsafeTimer);
    loader.classList.remove('is-hidden');
    loader.setAttribute('aria-hidden', 'false');
    failsafeTimer = window.setTimeout(hide, maximumVisibleMs);
  };

  const hide = () => {
    const wait = Math.max(0, minimumVisibleMs - (performance.now() - startedAt));
    window.clearTimeout(hideTimer);
    window.clearTimeout(failsafeTimer);
    hideTimer = window.setTimeout(() => {
      loader.classList.add('is-hidden');
      loader.setAttribute('aria-hidden', 'true');
    }, wait);
  };

  if (document.readyState === 'complete') hide();
  else window.addEventListener('load', hide, { once: true });

  window.setTimeout(hide, 2200);
  window.addEventListener('pageshow', hide);
  window.addEventListener('visibilitychange', () => {
    if (!document.hidden) hide();
  });

  document.addEventListener('click', (event) => {
    if (
      event.defaultPrevented ||
      event.button !== 0 ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey
    ) return;

    if (event.target.closest(
      '#checkout, #CartDrawer-Checkout, [name="checkout"], [data-checkout], .shopify-payment-button'
    )) return;

    const link = event.target.closest('a[href]');
    if (!link || link.hasAttribute('download') || link.target === '_blank') return;
    if (link.dataset.noPageLoader !== undefined) return;

    const destination = new URL(link.href, window.location.href);
    if (destination.origin !== window.location.origin) return;
    if (destination.pathname === '/checkout' || destination.pathname.startsWith('/checkouts/')) return;

    const sameDocument = destination.pathname === window.location.pathname &&
      destination.search === window.location.search;
    if (sameDocument && destination.hash) return;

    event.preventDefault();
    show();
    window.clearTimeout(navigationTimer);
    navigationTimer = window.setTimeout(() => {
      window.location.assign(destination.href);
    }, 140);
  });
})();
